/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CancelReattachmentRequestDto } from './CancelReattachmentRequestDto';
import {
    CancelReattachmentRequestDtoFromJSON,
    CancelReattachmentRequestDtoFromJSONTyped,
    CancelReattachmentRequestDtoToJSON,
    CancelReattachmentRequestDtoToJSONTyped,
} from './CancelReattachmentRequestDto';

/**
 * 
 * @export
 * @interface CancelWorkOrderRequestDto
 */
export interface CancelWorkOrderRequestDto {
    /**
     * 
     * @type {object}
     * @memberof CancelWorkOrderRequestDto
     */
    reason?: object | null;
    /**
     * 
     * @type {Array<CancelReattachmentRequestDto>}
     * @memberof CancelWorkOrderRequestDto
     */
    reattachments: Array<CancelReattachmentRequestDto>;
}

/**
 * Check if a given object implements the CancelWorkOrderRequestDto interface.
 */
export function instanceOfCancelWorkOrderRequestDto(value: object): value is CancelWorkOrderRequestDto {
    if (!('reattachments' in value) || value['reattachments'] === undefined) return false;
    return true;
}

export function CancelWorkOrderRequestDtoFromJSON(json: any): CancelWorkOrderRequestDto {
    return CancelWorkOrderRequestDtoFromJSONTyped(json, false);
}

export function CancelWorkOrderRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelWorkOrderRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
        'reattachments': ((json['reattachments'] as Array<any>).map(CancelReattachmentRequestDtoFromJSON)),
    };
}

export function CancelWorkOrderRequestDtoToJSON(json: any): CancelWorkOrderRequestDto {
    return CancelWorkOrderRequestDtoToJSONTyped(json, false);
}

export function CancelWorkOrderRequestDtoToJSONTyped(value?: CancelWorkOrderRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'reattachments': ((value['reattachments'] as Array<any>).map(CancelReattachmentRequestDtoToJSON)),
    };
}

